/* eslint-disable @typescript-eslint/no-unused-vars */
import { IAutoCompletePrefix, ISearchContext } from "api/interfaces/search.type";
import { getDynamicUrlPrefixApi } from "api/search/getDynamicUrlPrefixApi";
import { IVehicle } from "interfaces/session/IVehicle";
import { NextRouter } from "next/router";
import qs from "query-string";
import { setRecentSearches } from "util/localStorageUtils";

interface IUpdatedContext extends ISearchContext {
  year?: string;
  make?: string;
  model?: string;
}

export function getDynamicUrlPrefixSearch(suggestion: IAutoCompletePrefix, selectedVehicle : IVehicle | null, router: NextRouter, callback?: () => void) {
  const { context } = suggestion;
  const { year, make, model } = selectedVehicle || {};
  const updatedContext: IUpdatedContext = {
    ...context, year, make, model,
  };

  let skuQueryParams = "";

  if ("skus" in updatedContext) {
    const skus = updatedContext.skus || [];
    if (skus.length > 0) {
      skuQueryParams = skus.map((sku) => `skus=${sku}`).join("&");
    }
    delete updatedContext.skus;
  }

  setRecentSearches(suggestion);
  getDynamicUrlPrefixApi(updatedContext, skuQueryParams)
    .then(({ data }) => {
      const { queryParams, url, pageType } = data;
      const queryString = qs.stringify(queryParams);

      router.push(queryString ? `${url}?${queryString}&isSearch=true` : `${url}?isSearch=true`, queryString ? `${url}?${queryString}` : url).then(() => {
        if (callback) {
          callback();
        }
      });
    });
}
